"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CookieAgreementsContextProvider = exports.useCookieAgreements = void 0;
var _react = _interopRequireWildcard(require("react"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _router = require("next/router");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
var __jsx = _react["default"].createElement;
var CookieAgreementsContext = /*#__PURE__*/_react["default"].createContext();
var CookieAgreementsContextProvider = function CookieAgreementsContextProvider(_ref) {
  var children = _ref.children,
    analyticsID = _ref.analyticsID,
    gtmID = _ref.gtmID,
    fbID = _ref.fbID;
  var cookieName = global.__appConfig__.agreementsCookieName;
  var cookie = _jsCookie["default"].get(cookieName);
  var _useState = (0, _react.useState)(cookie ? JSON.parse(cookie) : false),
    cookieAgreements = _useState[0],
    setCookieAgreementsValue = _useState[1];
  if (!cookieAgreements) {
    if (cookie) {
      setCookieAgreementsValue(JSON.parse(cookie));
    }
  }
  var setCookieAgreementsState = function setCookieAgreementsState(values) {
    setCookieAgreementsValue(values);
  };
  var setCookieAgreements = function setCookieAgreements(values) {
    _jsCookie["default"].set(cookieName, JSON.stringify(values), {
      expires: 60
    });
    setCookieAgreementsValue(values);
  };
  return __jsx(CookieAgreementsContext.Provider, {
    value: {
      cookieAgreements: cookieAgreements,
      analyticsID: analyticsID,
      gtmID: gtmID,
      fbID: fbID,
      setCookieAgreementsState: setCookieAgreementsState,
      setCookieAgreements: setCookieAgreements
    }
  }, children);
};
exports.CookieAgreementsContextProvider = CookieAgreementsContextProvider;
var useCookieAgreements = function useCookieAgreements() {
  var router = (0, _router.useRouter)();
  var cookie = _jsCookie["default"].get(global.__appConfig__.agreementsCookieName);
  var _useContext = (0, _react.useContext)(CookieAgreementsContext),
    cookieAgreements = _useContext.cookieAgreements,
    setCookieAgreementsState = _useContext.setCookieAgreementsState;
  (0, _react.useEffect)(function () {
    if (cookie && !cookieAgreements) {
      setCookieAgreementsState(JSON.parse(cookie));
    }
  }, []);
  (0, _react.useEffect)(function () {
    if (!cookie) {
      setCookieAgreementsState(false);
    }
  }, [router.asPath]);
  return (0, _react.useContext)(CookieAgreementsContext);
};
exports.useCookieAgreements = useCookieAgreements;